export default __webpack_public_path__ + "static/media/games.2f324fa0.svg";